import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { groupBy } from 'lodash';

import { Button, Spinner, Text, TextType } from '@hum/ui-library';
import { ConnectorOption } from '@hum/types';
import { EmptyConnectorTab, ConnectionCard } from '../components';

export type ConnectorTabProps = {
  connections?: ConnectorOption[];
  icon: string;
  title: string;
  description: string;
  isLoading?: boolean;
  isBank?: boolean;
};

export const ConnectorTab = ({
  connections,
  icon,
  title,
  description,
  isLoading,
  isBank = false,
}: ConnectorTabProps) => {
  const location = useLocation();
  const history = useHistory();

  const groupedConnections = groupBy(
    connections,
    ({ connectorType }) => connectorType
  );

  if (isLoading || !connections) {
    return <Spinner fullScreen />;
  }

  if (connections.length > 0) {
    return (
      <>
        {!isBank ? (
          <Button
            className="my-8"
            onClick={() =>
              history.push(`${location.pathname}/connect${location.search}`)
            }
          >
            Add linked account
          </Button>
        ) : (
          <>
            <div className="flex items-center justify-between my-8">
              <Text type={TextType.PAGE_HEADING}>Bank Accounts</Text>
              <Button
                onClick={() =>
                  history.push(`${location.pathname}/connect${location.search}`)
                }
              >
                Add linked account
              </Button>
            </div>
            <div className="mb-8">
              <Text type={TextType.BODY_M}>
                Ensure you have added all bank accounts relevant to your
                business. By connecting to your bank, you will increase the
                number of funding opportunities your business will be eligible
                for. You can link as many accounts as needed.
              </Text>
            </div>
          </>
        )}
        {Object.entries(groupedConnections).map(
          ([connectorType, connectorConnections]) => (
            <ConnectionCard
              key={connectorType}
              connections={connectorConnections}
            />
          )
        )}
      </>
    );
  }

  return (
    <EmptyConnectorTab icon={icon} title={title} description={description} />
  );
};
